<template>
    <div class="jobOffers app">
        <header-child></header-child>
         <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="offset"
          >
            <div class="ul-box">
                <div class="li-box clearfix" v-for="(item, index) in dataList" :key="index" @click="goDetail(item.id)">
                    <p class="title fs16 mb8 color-blank txt_limit">{{item.post}}</p>
                    <div class="describe fs14 txt_limit2 color-light-gray">
                        <span v-if="item.type == 2">{{item.hospital_name}}</span>
                        <span v-else>{{item.group_name}}</span> | {{item.workplace}} | {{item.department}} | {{item.num}}
                        <span v-for="(key,index) in item.key" :key="index">| {{key}}</span> 
                    </div>
                </div>
            </div>
         </van-list>
    </div>
</template>

<script>
import HeaderChild from '@/components/HeaderChild'
import { List } from 'vant';
export default {
    components: {
        HeaderChild,
        [List.name]:List
    },
    data() {
        return {
            dataList:[],
            page:0,
            pageSize:8,
            alltotal:0,
            isUpLoading:false,//上拉加载
            upFinished:false,//上拉加载完毕
            offset:200,//滚动条与底部距离小于 offset 时触发load事件
        };
    },
    created() {
       
    },
    mounted() {
        
    },
    methods: {
        onLoad(){ 
            let self = this;
            setTimeout(() => {
                this.$axios.post(this.api.recruit.list,{
                    page:this.page+1,
                    page_size:this.pageSize
                },res =>{
                    this.dataList=this.dataList.concat(res.data);
                    for(var i in this.dataList){
                        var keyword_ids=[];
                        var item=this.dataList[i];
                        if(item.keyword){
                            item.keyword=item.keyword.replace(/，/ig,',');
                            if(item.keyword.indexOf(",") == -1){
                                keyword_ids.push(item.keyword);
                            }
                            else{
                                var strs=item.keyword.split(","); //字符分割
                                keyword_ids=strs;
                            }
                        }
                        this.$set(this.dataList[i], 'key', keyword_ids)
                    } 
                    this.alltotal=Number(res.pageInfo.totalCount);
                    this.isUpLoading = false;
                    this.page++;
                    if (this.dataList.length >= this.alltotal) {
                        this.upFinished = true;
                    }
                });
            }, 500);
           
        },
       goDetail:function(id){
            this.$router.push('/recruitDetail/'+id+'.html');
       }
    },
    
};
</script>

<style scoped lang="less">
.ul-box{
    padding:16px;
    .li-box{
        height:86px;
        padding:8px;
        background:#fff;
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
        border-radius:6px;
        margin-bottom:8px;
        .title{
            height:22px;
            line-height:22px;
        }
        .describe{
            height:40px; 
            line-height:20px;
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/view/jobOffers/index.vue